import React from 'react'
import './gallery.css';

const Gallery =()=> {
  return (
    <div className='lightbox-gallery' style={{padding:'20px'}}>
        <div className='container '>

        <>
  {/* Gallery */}
  <div className="row">
    <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
    <a href="https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp" data-lightbox="photos">
      <img
        src="https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp"
        className="w-100 shadow-1-strong rounded mb-4"
        alt="Boat on Calm Water"
       
      />
    </a>
    <a href="https://mdbcdn.b-cdn.net/img/Photos/Vertical/mountain1.webp" data-lightbox="photos">
      <img
        src="https://mdbcdn.b-cdn.net/img/Photos/Vertical/mountain1.webp"
        className="w-100 shadow-1-strong rounded mb-4"
        alt="Wintry Mountain Landscape"
      />
      </a>
    </div>
    <div className="col-lg-4 mb-4 mb-lg-0">
    <a href="https://mdbcdn.b-cdn.net/img/Photos/Vertical/mountain2.webp" data-lightbox="photos">
      <img
        src="https://mdbcdn.b-cdn.net/img/Photos/Vertical/mountain2.webp"
        className="w-100 shadow-1-strong rounded mb-4"
        alt="Mountains in the Clouds"
      />
    </a>
    <a href="https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp" data-lightbox="photos">
      <img
        src="https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp"
        className="w-100 shadow-1-strong rounded mb-4"
        alt="Boat on Calm Water"
      />
      </a>
    </div>
    <div className="col-lg-4 mb-4 mb-lg-0">
    <a href="https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(18).webp" data-lightbox="photos">
      <img
        src="https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(18).webp"
        className="w-100 shadow-1-strong rounded mb-4"
        alt="Waves at Sea"
      />
      </a>
      <a href="https://mdbcdn.b-cdn.net/img/Photos/Vertical/mountain3.webp" data-lightbox="photos">
      <img
        src="https://mdbcdn.b-cdn.net/img/Photos/Vertical/mountain3.webp"
        className="w-100 shadow-1-strong rounded mb-4"
        alt="Yosemite National Park"
      />
      </a>
    </div>
  </div>
</>




        </div>
      
    </div>
  )
}

export default Gallery
